"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/patientResponse/PatientThread.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _PatientMessage = require('./PatientMessage'); var _PatientMessage2 = _interopRequireDefault(_PatientMessage);
var _MessageActions = require('./MessageActions'); var _MessageActions2 = _interopRequireDefault(_MessageActions);

var _thread = require('./thread');


// How near the top older messages start loading, and how near the bottom
// counts as reading the newest message.
const LOAD_OLDER_WITHIN_PX = 160
const AT_BOTTOM_WITHIN_PX = 80
// The on-screen keyboard's least height (as PatientPage reads it), and how
// long after it goes the page has settled back.
const KEYBOARD_MIN_HEIGHT = 150
const BACK_TO_NEWEST_AFTER_MS = 400

// How long a message the patient jumped to stays lit.
const HIGHLIGHT_MS = 1500




















// The server has it, so it can take a reaction or a reply; a recalled
// message takes neither.
// An auto-reply takes no reply or reaction: it has no sender to answer.
const isActionable = (item) =>
  !item.row.SendState && !item.row.LocalKey && !_thread.isRecalled.call(void 0, item.row) && !_thread.isAutoReply.call(void 0, item.row)

const isAtBottom = (el) => el.scrollHeight - el.scrollTop - el.clientHeight <= AT_BOTTOM_WITHIN_PX

const messageKeys = (items) => {
  const messages = items.filter((item) => item.kind === 'message')
  return { oldest: _optionalChain([messages, 'access', _ => _[0], 'optionalAccess', _2 => _2.key]), newest: messages[messages.length - 1] }
}

/* The scrolling history. It opens on the newest message, follows new ones
 * while the patient is reading the bottom (and always for their own), and
 * keeps its place when older messages load above. */
const PatientThread = ({ items, onLoadOlder, onRetry, onReact, onReply, onCopy }) => {
  const historyRef = _react.useRef(null)
  const [openActions, setOpenActions] = _react.useState(null)
  const [highlightedKey, setHighlightedKey] = _react.useState(null)

  const openActionsFor = _react.useCallback.call(void 0, (item, anchor, reactionsOnly) => {
    setOpenActions({ item, anchor, reactionsOnly, variant: _MessageActions.actionsVariant.call(void 0, ) })
  }, [])
  const closeActions = _react.useCallback.call(void 0, () => setOpenActions(null), [])

  // A quote takes the patient to its message when the thread has it.
  const jumpTo = _react.useCallback.call(void 0, (key) => {
    const target = _optionalChain([historyRef, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.querySelector, 'call', _5 => _5(`[id="${CSS.escape(key)}"]`)])
    if (!target) return
    target.scrollIntoView({ block: 'center', behavior: 'smooth' })
    setHighlightedKey(key)
  }, [])
  _react.useEffect.call(void 0, () => {
    if (!highlightedKey) return undefined
    const timer = setTimeout(() => setHighlightedKey(null), HIGHLIGHT_MS)
    return () => clearTimeout(timer)
  }, [highlightedKey])

  // The open menu's message, as it is now (a resend may have changed it).
  const openItem = openActions && _optionalChain([items, 'optionalAccess', _6 => _6.find, 'call', _7 => _7((item) =>
    item.kind === 'message' && item.key === openActions.item.key)])
  const menuReact = _react.useCallback.call(void 0, (emoji) => {
    if (openItem) onReact(openItem.row, emoji)
    setOpenActions(null)
  }, [openItem, onReact])
  const menuReply = _react.useCallback.call(void 0, () => {
    if (openItem && onReply) onReply(openItem)
    setOpenActions(null)
  }, [openItem, onReply])
  const menuCopy = _react.useCallback.call(void 0, () => {
    if (openItem) onCopy(openItem.row)
    setOpenActions(null)
  }, [openItem, onCopy])
  const [isLoadingOlder, setIsLoadingOlder] = _react.useState.call(void 0, false)
  const loadingOlderRef = _react.useRef.call(void 0, false)
  const hasAllRef = _react.useRef.call(void 0, false)
  // The scroll position and messages as last laid out.
  const lastRef = _react.useRef(null)

  const loadOlder = _react.useCallback.call(void 0, () => {
    if (loadingOlderRef.current || hasAllRef.current) return
    loadingOlderRef.current = true
    setIsLoadingOlder(true)
    onLoadOlder()
      .then(count => { if (count === 0) hasAllRef.current = true })
      .catch(() => null)
      .finally(() => {
        loadingOlderRef.current = false
        setIsLoadingOlder(false)
      })
  }, [onLoadOlder])

  _react.useLayoutEffect.call(void 0, () => {
    const el = historyRef.current
    if (!el || !items) return
    const { oldest, newest } = messageKeys(items)
    const last = lastRef.current

    if (!_optionalChain([last, 'optionalAccess', _8 => _8.newest])) {
      el.scrollTop = el.scrollHeight
    } else if (_optionalChain([newest, 'optionalAccess', _9 => _9.key]) !== last.newest) {
      const wasAtBottom = last.height - last.top - el.clientHeight <= AT_BOTTOM_WITHIN_PX
      if (wasAtBottom || _optionalChain([newest, 'optionalAccess', _10 => _10.mine])) el.scrollTop = el.scrollHeight
    } else if (oldest !== last.oldest) {
      // Older messages came in above: keep the same messages in view.
      el.scrollTop = last.top + (el.scrollHeight - last.height)
    }
    lastRef.current = { height: el.scrollHeight, top: el.scrollTop, oldest, newest: _optionalChain([newest, 'optionalAccess', _11 => _11.key]) }

    // A short history doesn't fill the view, so it never scrolls to the top.
    if (newest && el.scrollHeight <= el.clientHeight) loadOlder()
  }, [items, loadOlder])

  // The keyboard opening or closing changes what's visible without always
  // resizing the history (the page slides instead). A patient reading the
  // newest message when the keyboard came up is shown it again once it has
  // gone, however it went, after the page has settled back (PatientPage).
  _react.useEffect.call(void 0, () => {
    const viewport = window.visualViewport
    const el = historyRef.current
    if (!viewport || !el) return undefined
    let keyboardOpen = false
    let newestWhenOpened = false
    let timer
    const onViewportResize = () => {
      const open = document.documentElement.clientHeight - viewport.height > KEYBOARD_MIN_HEIGHT
      if (open && !keyboardOpen) newestWhenOpened = isAtBottom(el)
      if (!open && keyboardOpen && newestWhenOpened) {
        clearTimeout(timer)
        timer = setTimeout(() => {
          el.scrollTop = el.scrollHeight
          lastRef.current = lastRef.current && { ...lastRef.current, height: el.scrollHeight, top: el.scrollTop }
        }, BACK_TO_NEWEST_AFTER_MS)
      }
      keyboardOpen = open
    }
    viewport.addEventListener('resize', onViewportResize)
    return () => {
      clearTimeout(timer)
      viewport.removeEventListener('resize', onViewportResize)
    }
  }, [])

  // The keyboard or a resize shrinks the view: stay on the newest message.
  _react.useEffect.call(void 0, () => {
    const el = historyRef.current
    if (!el || typeof ResizeObserver === 'undefined') return undefined
    let height = el.clientHeight
    const observer = new ResizeObserver(() => {
      const last = lastRef.current
      if (last && last.height - last.top - height <= AT_BOTTOM_WITHIN_PX) el.scrollTop = el.scrollHeight
      height = el.clientHeight
      lastRef.current = last && { ...last, height: el.scrollHeight, top: el.scrollTop }
    })
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const handleScroll = _react.useCallback.call(void 0, () => {
    const el = historyRef.current
    if (!el || !lastRef.current) return
    lastRef.current = { ...lastRef.current, height: el.scrollHeight, top: el.scrollTop }
    if (el.scrollTop <= LOAD_OLDER_WITHIN_PX && !isAtBottom(el)) loadOlder()
  }, [loadOlder])

  const hasMessages = !!_optionalChain([items, 'optionalAccess', _12 => _12.some, 'call', _13 => _13(item => item.kind === 'message')])

  return (
    // The history scrolls here, inside its region, and takes keyboard focus
    // so it can be scrolled without a pointer.
    _react2.default.createElement('section', {
      className: "patient-conversation--history",
      'aria-label': "Conversation history" ,
      tabIndex: 0,
      ref: historyRef,
      onScroll: handleScroll, __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}}

      ,  !items && (
        _react2.default.createElement('div', { className: "patient-thread--placeholder", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}
          , _react2.default.createElement('span', { className: "patient-thread--spinner", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}} ), "Loading messages…"

        )
      )
      ,  items && !hasMessages && (
        _react2.default.createElement('p', { className: "patient-thread--placeholder", __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}, "No messages yet"  )
      )
      ,  items && hasMessages && (
        _react2.default.createElement('div', { className: "patient-thread", __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
          ,  isLoadingOlder && (
            _react2.default.createElement('div', { className: "patient-thread--older", role: "status", 'aria-label': "Loading earlier messages"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
              , _react2.default.createElement('span', { className: "patient-thread--spinner", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}} )
            )
          )
          ,  items.map(item => {
            switch (item.kind) {
              case 'day':
                return (
                  _react2.default.createElement('div', { key: item.key, className: "patient-thread--day", __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
                    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 220}},  item.label )
                  )
                )
              case 'meta':
                return _react2.default.createElement('p', { key: item.key, className: "patient-thread--meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}},  item.text )
              default:
                return (
                  _react2.default.createElement(_PatientMessage2.default, {
                    key: item.key,
                    item: item,
                    highlighted: highlightedKey === item.key,
                    actionable: isActionable(item),
                    onRetry: onRetry,
                    onReact: onReact,
                    onOpenActions: openActionsFor,
                    onJump: jumpTo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}
                  )
                )
            }
          }) 
        )
      )
      ,  openActions && openItem && (
        _react2.default.createElement(_MessageActions2.default, {
          variant: openActions.variant,
          anchor: openActions.anchor,
          senderName: openItem.mine ? 'You' : openItem.senderName,
          text: _thread.summaryOf.call(void 0, openItem.row),
          reactions: openItem.row.Reactions,
          reactionsOnly: openActions.reactionsOnly,
          onReact: menuReact,
          onReply: onReply ? menuReply : null,
          onCopy: openItem.row.TextContent ? menuCopy : null,
          onClose: closeActions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, PatientThread)
